function toDate(value) {
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

function startOfDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
}

export function resolveLast30DaysWindow(now = new Date()) {
  return {
    from: startOfDay(new Date(now.getFullYear(), now.getMonth(), now.getDate() - 29)),
    to: now,
  };
}

export function countUniqueAppointmentPatients(rows = [], { from = null, to = null } = {}) {
  if (!Array.isArray(rows)) return 0;

  return new Set(
    rows
      .filter((row) => {
        if (!from && !to) return true;
        const date = toDate(row?.appointment_date);
        if (!date) return false;
        if (from && date < from) return false;
        if (to && date > to) return false;
        return true;
      })
      .map((row) =>
        String(
          row?.patient_id ||
            row?.patient_profile_id ||
            row?.patient_email ||
            row?.patient_name ||
            ""
        ).trim()
      )
      .filter(Boolean)
  ).size;
}

export async function fetchDoctorUniquePatientCount(
  supabaseClient,
  doctorIds = [],
  { from = null, to = null } = {},
) {
  const ids = Array.from(
    new Set(
      (Array.isArray(doctorIds) ? doctorIds : [doctorIds])
        .map((value) => String(value || "").trim())
        .filter(Boolean)
    )
  );
  if (!supabaseClient || ids.length === 0) return null;

  let query = supabaseClient
    .from("appointments")
    .select("patient_id,appointment_date,status,superseded_by_appointment_id")
    .in("doctor_id", ids)
    .not("patient_id", "is", null)
    .is("superseded_by_appointment_id", null)
    .neq("status", "cancelled");

  if (from instanceof Date && !Number.isNaN(from.getTime())) {
    query = query.gte("appointment_date", from.toISOString());
  }
  if (to instanceof Date && !Number.isNaN(to.getTime())) {
    query = query.lte("appointment_date", to.toISOString());
  }

  const { data, error } = await query;
  if (error) throw error;
  return countUniqueAppointmentPatients(data, { from, to });
}

export async function fetchDoctorPublicPatientCount(supabaseClient, doctorId) {
  const id = String(doctorId || "").trim();
  if (!supabaseClient || !id) return null;

  const { data, error } = await supabaseClient.rpc("get_subscription_usage", {
    user_uuid: id,
  });
  if (error) return null;

  const count = Number(data?.patients_count ?? data?.patientsCount);
  return Number.isFinite(count) ? count : null;
}
